/**
 * 价格警报服务
 */

import { apiClient } from './apiClient';

export class PriceAlertService {
  /**
   * 获取价格警报
   */
  async getPriceAlerts(params?: { limit?: number; offset?: number }): Promise<any> {
    const response = await apiClient.get<any>('/price-alerts', { params });

    if (!response.success) {
      throw new Error(response.message || '获取价格警报失败');
    }

    return response.data;
  }

  /**
   * 获取最近价格警报
   */
  async getRecentPriceAlerts(params?: { hours?: number }): Promise<any> {
    const response = await apiClient.get<any>('/price-alerts/recent', { params });

    if (!response.success) {
      throw new Error(response.message || '获取最近价格警报失败');
    }

    return response.data;
  }

  /**
   * 全库搜索历史价格警报（不限制时间）
   */
  async searchPriceAlerts(query: string, limit: number = 100, offset: number = 0): Promise<any> {
    const response = await apiClient.get<any>(`/price-alerts/search`, {
      params: { q: query, limit, offset },
    });

    if (!response.success) {
      throw new Error(response.message || '搜索历史价格警报失败');
    }

    return response.data;
  }
}

export const priceAlertService = new PriceAlertService();
